import fetch from 'cross-fetch';
/**
 * Responsible for making web requests.
 *
 */
var HttpRequester = /** @class */ (function () {
    function HttpRequester() {
    }
    HttpRequester.prototype.post = function (url, body, headers) {
        var data = JSON.stringify(body);
        var fetchInit = {
            method: 'POST',
            headers: headers,
            body: data,
            keepalive: true
        };
        if (typeof (window) !== 'undefined' && window.fetch) {
            return window.fetch(url, fetchInit);
        }
        return fetch(url, fetchInit);
    };
    HttpRequester.prototype.get = function (url) {
        var fetchInit = {
            method: 'GET',
            mode: 'no-cors',
        };
        if (typeof (window) !== 'undefined' && window.fetch) {
            return window.fetch(url, fetchInit);
        }
        return fetch(url, fetchInit);
    };
    return HttpRequester;
}());
export { HttpRequester };
//# sourceMappingURL=HttpRequester.js.map